import { Component } from '@angular/core';
import { CompletedEventCategoryModel } from 'src/app/models/completed-event/completed-event-category.model';

@Component({
    selector: 'app-person-competency-matrix-widget-demo',
    templateUrl: './person-competency-matrix-widget-demo.component.html',
    styleUrl: './person-competency-matrix-widget-demo.component.scss',
    standalone: false
})
export class PersonCompetencyMatrixWidgetDemoComponent {
  personCompetencyMatrixData: CompletedEventCategoryModel[] = [
    { categoryId: '1', categoryName: 'Communication', countOfCompletedEvents: 8 },
    { categoryId: '2', categoryName: 'Leadership', countOfCompletedEvents: 5 },
    { categoryId: '3', categoryName: 'Technical Skills', countOfCompletedEvents: 12 },
    { categoryId: '4', categoryName: 'Time Management', countOfCompletedEvents: 7 },
    { categoryId: '5', categoryName: 'Problem Solving', countOfCompletedEvents: 9 },
  ];
}
